import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { HelpersService } from 'src/app/shared/services/helpers.service';

@Component({
  selector: 'app-input-mail-filter',
  templateUrl: './input-mail-filter.component.html',
  styleUrls: ['./input-mail-filter.component.scss']
})
export class InputMailFilterComponent implements OnInit, OnChanges {

  @Input() block: any;
  @Input() resetValue: any;
  @Input() firstInput: any;
  @Input() lastInput: any;
  @Output() onTyped = new EventEmitter();
  public value = null;


  constructor(public helpersService: HelpersService) {
  }

  ngOnInit() {
    if (this.block && this.block.value_sel) {
      this.value = this.block.value_sel[this.block.filter_name];
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes['resetValue'] && changes['resetValue'].currentValue) {
      this.value = null;
    }
  }

  changeVal(event: any): void {
    const ret: any = {};
    ret[this.block.filter_name] = event;
    this.onTyped.emit(ret[this.block.filter_name]);
  }

}
